import React from 'react';

const page = () => {
    return (
        <div>
            <h1>OOps, 404 not found :( just why</h1>
        </div>
    )
}

export default page;